<script>
    export let image = null;
    export let x = 0;
    export let y = 1;
    export let width = 16;
    export let height = (width * 53) / 336;
    export let text = "";
    export let defaultText = "";

    const styles = [
        `--image:url(../assets/${image})`,
        `--x:${x}vw`,
        `--y:${y}vw`,
        `--width:${width}vw`,
        `--height:${height}vw`,
        `--textOffset: ${width / 12}vw`,
        `--textSize: ${width / 13}vw`,
    ];
</script>

<div style={styles.join(";")}>
    <span>{text || defaultText}</span>
</div>

<style>
    div {
        position: absolute;
        left: var(--x);
        top: var(--y);
        width: var(--width);
        height: var(--height);
        background-image: var(--image);
        background-size: contain;
        color: #fff;
        text-align: right;
        line-height: var(--height);
        font-size: var(--textSize);
    }
    div > span {
        padding-right: var(--textOffset);
    }
</style>
